import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPagina from '../../actions/preco/alterarRegistrosPorPaginaPreco'
import determinarPaginaAtual from '../../actions/preco/determinarPaginaAtualPreco'

export class PaginacaoPedidos extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    precos: state.precoPaginacao.precos,
    total: state.precoPaginacao.totalRegistros,
    paginaAtual: state.paginaAtualPreco,
    registrosPorPagina: state.registrosPorPaginaPreco
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoPedidos)
